import React, { useState } from 'react';
import { Box, Container, FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material';
import KayitIstatistikleri from './KayitIstatistikleri';
import { motion } from 'framer-motion';
import OdemelerRaporu from './OdemelerRaporu';
import { getCurrentSezon, getSezonOptions } from '../../../utils/sezon';

const sezonOptions = getSezonOptions();

const DashboardPage: React.FC = () => {
  const [selectedSezon, setSelectedSezon] = useState<number | 'all'>(getCurrentSezon());

  const handleSezonChange = (event: SelectChangeEvent<number | 'all'>) => {
    const value = event.target.value;
    setSelectedSezon(value === 'all' ? 'all' : Number(value));
  };

  return (
    <Container maxWidth="lg">
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Box sx={{ my: 4 }}>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
            <FormControl size="small" sx={{ minWidth: 200 }}>
              <InputLabel id="dashboard-sezon-select-label">Sezon</InputLabel>
              <Select
                labelId="dashboard-sezon-select-label"
                id="dashboard-sezon-select"
                value={selectedSezon}
                label="Sezon"
                onChange={handleSezonChange}
              >
                <MenuItem value="all">Tüm Sezonlar</MenuItem>
                {sezonOptions.map((year) => (
                  <MenuItem key={year} value={year}>
                    {year - 1} - {year} Eğitim Yılı
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          <KayitIstatistikleri sezon={selectedSezon} />
          <OdemelerRaporu sezon={selectedSezon} />

          {/* Diğer dashboard bileşenleri */}
        </Box>
      </motion.div>
    </Container>
  );
};

export default DashboardPage;